import React from 'react';
import { Trash2 } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import { CommentAvatar, CommentAgentBadge } from './CommentAuthor';
import CommentBody from './CommentBody';

/**
 * The task's comment thread, oldest first: avatar, author (and the agent
 * badge), when, the body, and who it mentions. Moved out of TaskDetailModal
 * when the modal was redesigned (05.10.2026).
 */
export default function TaskCommentList({ comments, members, labelOf, timeAgo, onDelete }) {
  return (
    <div className="task-detail-comments-list">
      {comments.map((c) => {
        const author = c.authorName || 'User';
        return (
          <div key={c.id} className="task-detail-comment">
            {/* The real avatar. Comments have carried `authorId` since mentions
                shipped; ones written before that have none, and UserAvatar
                falls back to initials on its own for exactly that case. */}
            <CommentAvatar className="task-detail-comment-avatar" comment={c} name={author} />
            <div className="task-detail-comment-main">
              <div className="task-detail-comment-head">
                <span className="task-detail-comment-author">{author}</span>
                <CommentAgentBadge comment={c} />
                <Tooltip content={new Date(c.createdAt).toLocaleString()} side="top">
                  <span className="task-detail-comment-time">{timeAgo(c.createdAt)}</span>
                </Tooltip>
                <button type="button" className="task-detail-comment-delete" onClick={() => onDelete(c.id)} aria-label="Delete comment">
                  <Trash2 size={12} /> Delete
                </button>
              </div>
              <CommentBody comment={c} />
              {/* Absent on every comment written before mentions existed —
                  rendered only when present, never backfilled. */}
              {Array.isArray(c.mentions) && c.mentions.length > 0 && (
                <div className="task-detail-comment-mentions">
                  {c.mentions.map((uid) => {
                    const m = members.find((x) => String(x.id) === String(uid));
                    return (
                      <span key={uid} className="task-detail-mention-chip">
                        @{m ? labelOf(m) : 'unknown'}
                      </span>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
